import { municipalidad_get_url } from "./urlBase"
import { apiCall } from "./apiCall";

const listar_municipalidades = async ( region, provincia, distrito, all ) => {
    try {
        const resp = await apiCall( 'GET', `${municipalidad_get_url}/${region}/${provincia}/${distrito}/${all}`, null )
        const response = resp.data

        if ( response.Success ) {
            return response
        }
        else {
            console.log('municipalidadHelper', '15')
            throw response
        }

    } catch ( e ) {
        console.log('municipalidadHelper', '20')
        throw e
    }
}

export {
    listar_municipalidades
}